export default __webpack_public_path__ + "static/media/bg_video.d45f9de8.mp4";